import { render, staticRenderFns } from "./CCascader2.vue?vue&type=template&id=19073e1d&scoped=true"
import script from "./CCascader2.vue?vue&type=script&lang=js"
export * from "./CCascader2.vue?vue&type=script&lang=js"
import style0 from "./CCascader2.vue?vue&type=style&index=0&id=19073e1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19073e1d",
  null
  
)

export default component.exports